import { Component, Input } from '@angular/core';

@Component({
  selector: 'mk-double-bounce',
  template: `
    <div class="sk-double-bounce">
      <div class="sk-child sk-double-bounce1" [style.background-color]="colorOne"></div>
      <div class="sk-child sk-double-bounce2" [style.background-color]="colorTwo"></div>
    </div>`,
  styles: [`.sk-double-bounce{width:40px;height:40px;position:relative;margin:40px auto}.sk-double-bounce .sk-child{width:100%;height:100%;border-radius:50%;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:2s ease-in-out infinite sk-doubleBounce;animation:2s ease-in-out infinite sk-doubleBounce}.sk-double-bounce .sk-double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-doubleBounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-doubleBounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}`]
})
export class DoubleBounceComponent {
  @Input() colorOne = '#da4733';
  @Input() colorTwo = '#3b78e7';
}
